import { toast } from 'sonner';

import { cn } from '@/lib/utils';

type ToastVariant = 'success' | 'error';

const commonToastStyles = 'font-medium! text-sm';

type SonnerOptions = NonNullable<Parameters<typeof toast>[1]>;

const toastVariants: Record<ToastVariant, SonnerOptions> = {
  success: {
    classNames: {
      icon: 'text-green-500',
      toast: cn(commonToastStyles, 'bg-green-50! text-green-700 font'),
    },
  },
  error: {
    classNames: {
      icon: 'text-primary',
      toast: cn(commonToastStyles, 'bg-red-50! text-destructive-subtle-foreground!'),
    },
  },
};

type ShowToastType = {
  variant: ToastVariant;
  title: string;
  options?: SonnerOptions;
};

const showToast = ({ variant, title, options }: ShowToastType) => {
  const variantOptions = toastVariants[variant];

  const { classNames: variantClassNames, ...restOfVariantOptions } = variantOptions || {};
  const { classNames: optionClassNames, ...restOfOptions } = options || {};

  const mergedClassNames: SonnerOptions['classNames'] = {
    ...variantClassNames,
    ...optionClassNames,

    toast: cn(variantClassNames?.toast, optionClassNames?.toast),

    description: cn(variantClassNames?.description, optionClassNames?.description),
    icon: cn(variantClassNames?.icon, optionClassNames?.icon),
  };

  return toast[variant](title, {
    ...restOfVariantOptions,
    ...restOfOptions,
    dismissible: false,
    classNames: mergedClassNames,
  });
};

export default showToast;
